import Icon from '../components/Icon.vue'

Icon.register({
  'hospital-alt': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M544 96H416V32C416 14.3 401.7 0 384 0H192C174.3 0 160 14.3 160 32V96H32C14.3 96 0 110.3 0 128V496C0 504.8 7.2 512 16 512H560C568.8 512 576 504.8 576 496V128C576 110.3 561.7 96 544 96zM160 436C160 442.6 154.6 448 148 448H108C101.4 448 96 442.6 96 436V396C96 389.4 101.4 384 108 384H148C154.6 384 160 389.4 160 396V436zM160 308C160 314.6 154.6 320 148 320H108C101.4 320 96 314.6 96 308V268C96 261.4 101.4 256 108 256H148C154.6 256 160 261.4 160 268V308zM320 436C320 442.6 314.6 448 308 448H268C261.4 448 256 442.6 256 436V396C256 389.4 261.4 384 268 384H308C314.6 384 320 389.4 320 396V436zM320 308C320 314.6 314.6 320 308 320H268C261.4 320 256 314.6 256 308V268C256 261.4 261.4 256 268 256H308C314.6 256 320 261.4 320 268V308zM336 138C336 141.3 333.3 144 330 144H304V170C304 173.3 301.3 176 298 176H278C274.7 176 272 173.3 272 170V144H246C242.7 144 240 141.3 240 138V118C240 114.7 242.7 112 246 112H272V86C272 82.7 274.7 80 278 80H298C301.3 80 304 82.7 304 86V112H330C333.3 112 336 114.7 336 118V138zM480 436C480 442.6 474.6 448 468 448H428C421.4 448 416 442.6 416 436V396C416 389.4 421.4 384 428 384H468C474.6 384 480 389.4 480 396V436zM480 308C480 314.6 474.6 320 468 320H428C421.4 320 416 314.6 416 308V268C416 261.4 421.4 256 428 256H468C474.6 256 480 261.4 480 268V308z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hospital-alt.js
// module id = yKsl
// module chunks = 144